import MuiInputLabel from "@mui/material/InputLabel";

export default function InputLabel(props) {
  return <MuiInputLabel {...props} />;
}
